import React from 'react';
import Panel from '../../../../../components/outline/Panel';
import InputForm from '../../../../../components/form/InputForm';
import { formRequiredRules } from '../../../../../lib/formRules';
import BaseForm from '../../../../../components/form/BaseForm';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import SelectForm from '../../../../../components/form/SelectForm';
import {
  NOTICE_PRODUCT_TYPE_SELECT_LIST,
  PLACEHOLDER_TEXT_NOTICE_PRODUCT_PERIOD_DATE,
} from '../../../../../constants/service/app/noticeProductConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import './NoticeProductDetailInfo.scss';

const NoticeProductDetailInfo = (props) => {
  const { info, isEditable, form, setData } = props;
  const { storeName, storeId, status, title, content, memo, period } = info;

  return (
    <Panel className="notice-product-detail-info" name="notice-product-detail-info">
      <div className="panel-header">
        <div className="title">기본 정보</div>
      </div>

      <div className="panel-body">
        {/*브랜드 명*/}
        <BaseForm label="브랜드 명" content={<OpenBrandDetail text={storeName} storeId={storeId} />} />

        {/*공지사항 상태*/}
        <SelectForm
          label="공지사항 상태"
          form={form}
          isEditable={isEditable}
          initialValue={status}
          list={NOTICE_PRODUCT_TYPE_SELECT_LIST}
          name="status"
          onChange={(value) => {
            setData({ path: ['noticeProductDetail', 'info', 'status'], value });
          }}
        />

        {/*제목*/}
        <InputForm
          label="제목"
          form={form}
          isEditable={isEditable}
          rules={[formRequiredRules(true, REQUIRED_MSG), { type: 'email', message: '제목을 확인해주세요!' }]}
          initialValue={title}
          onChange={(value) =>
            setData({
              path: ['noticeProductDetail', 'info', 'title'],
              value,
            })
          }
          name="title"
          subContent={
            <div className="sub-info">
              <div>제목에 입력한 항목은 앱에 노출되지 않습니다</div>
            </div>
          }
        />

        {/*내용*/}
        <InputForm
          label="내용"
          className={'notice-product-info-content'}
          form={form}
          isEditable={isEditable}
          rules={[formRequiredRules(true, REQUIRED_MSG), { type: 'content', message: '내용을 확인해주세요!' }]}
          initialValue={content}
          onChange={(value) =>
            setData({
              path: ['noticeProductDetail', 'info', 'content'],
              value,
            })
          }
          name="content"
          subContent={
            <div className="sub-info">
              <div>내용에 적은 항목만 앱에 노출됩니다</div>
              <div>내용에 줄바꿈(엔터)이 많으면, 상세 이미지를 바로 보기에 불편할 수 있습니다.</div>
            </div>
          }
        />

        {/*메모*/}
        <InputForm
          label="메모"
          className={'notice-product-info-memo'}
          form={form}
          isEditable={isEditable}
          initialValue={memo}
          onChange={(value) =>
            setData({
              path: ['noticeProductDetail', 'info', 'memo'],
              value,
            })
          }
          name="memo"
        />

        {/*상품 공지사항 노출 기간*/}
        <BaseForm
          label="노출 기간"
          content={
            period.startDate && period.endDate ? (
              <DateRangePicker
                value={period}
                showTime={true}
                isEditable={isEditable}
                startText={PLACEHOLDER_TEXT_NOTICE_PRODUCT_PERIOD_DATE}
                endText={PLACEHOLDER_TEXT_NOTICE_PRODUCT_PERIOD_DATE}
                outFormat={DATE_FORMAT.YMD_HM_DASH_FORMAT}
                btnTextFormat={DATE_FORMAT.YMD_HM_DASH_FORMAT}
                format={DATE_FORMAT.YMD_HM_DASH_FORMAT}
                onSelect={(date) => console.log(date)}
              />
            ) : (
              '-'
            )
          }
          subContent={
            <div className="sub-info">
              <div>웹/앱에서 노출되는 기간입니다.</div>
            </div>
          }
        />
      </div>
    </Panel>
  );
};

export default NoticeProductDetailInfo;
